import { BILLING_CYCLE, planTypes, DEFAULT_MIN_HOST } from '@/common/constants';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import { get, throttle } from 'lodash';
import plansMixin from '@/plans/mx/plan';
import { isEmptyVal } from '@/utils';
import AddonMixin from '@/plans/mx/addon';

export default {
  mixins: [plansMixin, AddonMixin],
  data() {
    return {
      isExpanded: true,
      showPlanDetail: true,
      previousQuantity: DEFAULT_MIN_HOST,
    };
  },
  mounted() {
    this.previousQuantity = this.currentEditPlan?.cartInfo?.selected_number ?? DEFAULT_MIN_HOST;
    // refresh page
    this.$nextTick(() => {
      this.mx_validDownSellLicense(this.currentEditPlan?.cartInfo?.selected_number);
    });
  },
  computed: {
    ...mapState({
      planMapFlat: (state) => state.ShoppingCart.planMapFlat,
    }),
    ...mapGetters([
      'getSelectedPlans',
      'getCurrentBasePlanInfo',
      'currentEditPlan',
      'enableStandaloneCycleLimit',
      'basicConfig',
    ]),
    decreaseTips() {
      if (this.form.selectedNumber === this.previousQuantity) {
        if (this.basicConfig.downSellData.disableDownSell) {
          return this.$t('billing.error.can_not_bought_plan_tips');
        }

        return this.forNonStandardPriceTips;
      }

      return '';
    },
    minHost() {
      if (this.basicConfig.downSellData.disableDownSell || !this.isStandardPrice) return this.previousQuantity;
      return this.formPlan ? this.formPlan.min : 1;
    },
    maxHost() {
      return 9999;
    },
  },
  methods: {
    ...mapActions({
      switchSelectPlan: 'switchSelectPlan',
    }),
    ...mapMutations(['updateSelectPlan']),
    submitForm: throttle(function (v) {
      this.$nextTick(() => {
        if (!this.formPlan) {
          return;
        }

        if (isEmptyVal(v)) {
          this.form.selectedNumber = Math.max(this.formPlan?.cartInfo?.selected_number ?? 0, this.minHost);
        }
        this.mx_validDownSellLicense(this.form.selectedNumber);
        if (this.formPlan.plan_code === this.oldPlanCode) {
          this.updateSelectPlan({
            ...this.formPlan,
            cartInfo: {
              selected_number: this.form.selectedNumber,
            },
          });
        } else {
          this.switchSelectPlan([
            this.oldPlanCode,
            this.formPlan.plan_code,
            {
              selected_number: this.form.selectedNumber,
            },
          ]);
        }
        this.updateForm();
      });
    }, 200),
    getBillingCycleDisabledDesc(billingCycle /* Options' billing cycle */) {
      const shoppingCartSelectedPlan = this.getSelectedPlans.find((item) => item.type === planTypes.ZOOM_SCHEDULER);
      const { plans = [] } = this.getCurrentBasePlanInfo;
      const currentBasePlanType = get(plans, [0, 'type']);
      const currentBasePlanCycle = get(plans, [0, 'billing_cycle']);
      const basePlanName = this.$t(get(plans, [0, 'typeNameKey']));
      const isBulkLicenseAccountDisabled = this.basicConfig.isBulkLicenseAccount;
      // only for edit flow
      if (shoppingCartSelectedPlan.billing_cycle !== billingCycle && isBulkLicenseAccountDisabled) {
        return this.$t('billing.error.buld_acount_license');
      }
      if (
        currentBasePlanType !== planTypes.ZOOM_MEETING /* Only worked for Meeting & Scheduler */ ||
        currentBasePlanCycle ===
          billingCycle /* Meeting plan as the base plan, Meeting plan billing cycle === this Option billing cycle */ ||
        billingCycle === BILLING_CYCLE.MONTHLY /* Monthly always availble for Scheduler */ ||
        shoppingCartSelectedPlan.billing_cycle ===
          billingCycle /* Now user chosen plan === this Option billing cycle, happend on Edit & Add2Cart if user already bought a monthly Meeting and try to edit/buy annually Scheduler */ ||
        !this.enableStandaloneCycleLimit
      ) {
        return false;
      }
      const currentPlanName = this.title;
      return this.$t('billing.planform.annual_addon_disable_tooltip', [basePlanName, currentPlanName, basePlanName]);
    },
  },
};
